import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as Models from './_models'
@Injectable({ providedIn: 'root' })
export class FiltroService {

    private API_URL_AREAS = `${environment.apiUrl}/api/areas`;
    private API_URL_MCP = `${environment.apiUrl}/api/materias`;
    private API_URL_CURSOS_PARENT = `${environment.apiUrl}/api/cursos/buscar`;
    private API_URL_PERIODOS_PARENT = `${environment.apiUrl}/api/Periodos`;
    private API_URL_SESIONES = `${environment.apiUrl}/api/AdmisionesSesion/fechas/periodos`;

    constructor(
        private http: HttpClient,
        private snackBar: MatSnackBar
    ) { }

    getMaterias(): Observable<Models.MateriaMin[]> {
        return this.http.get<Models.MateriaMin[]>(`${this.API_URL_AREAS}`)
            .pipe(
                map((res: Models.MateriaMin[]) => res),
                catchError(err => this.handleError(err, of([]))),
                shareReplay(1)
            );
    }

    getMateriasMcp(): Observable<Models.MateriaMin[]> {
        return this.http.get<Models.MateriaMin[]>(`${this.API_URL_MCP}/area/mcp`);
    }

    getCursosParent(soloActivos = true): Observable<Models.CursoDto[]> {
        return this.http.get<Models.CursoDto[]>(
            `${this.API_URL_CURSOS_PARENT}`,
            { params: { seccionExclude: 5, soloActivos: soloActivos } }
        )
            .pipe(
                map((res: Models.CursoDto[]) => res),
                catchError(err => this.handleError(err, of([]))),
                shareReplay(1)
            );
    }

    getPeriodosParent(includeNonActive: boolean): Observable<Models.Periodo[]> {
        return this.http.get<Models.Periodo[]>(`${this.API_URL_PERIODOS_PARENT}/hijos/true/inactivos/${includeNonActive}`)
            .pipe(
                map((res: Models.Periodo[]) => res),
                catchError(err => this.handleError(err, of([]))),
                shareReplay(1)
            );
    }

    getSesiones(model: { ids: string }): Observable<Models.SesionDto[]> {
        return this.http.post<Models.SesionDto[]>(`${this.API_URL_SESIONES}`, model);
    }

    private handleError(err: any, res: Observable<any>) {
        let errorMessage: string;
        // = `Error ${err?.status}: ${err?.statusText}. Reintente la operación.`;
        if (err?.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err?.error?.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Backend returned code ${err?.status}: ${err?.body?.error}`;
        }
        this.snackBar.open(
            errorMessage,
            "Cerrar",
            {
                verticalPosition: "top",
                panelClass: ["error", "error-container"],
            }
        );
        console.error(err);
        // return res;
        return throwError(errorMessage);
    }

}
